import React from 'react';
import { defineMessages } from 'react-intl';

import Confirm from 'components/Confirm';
import Message from 'components/Message';

export const messages = defineMessages({
  title: {
    id: 'venue-page.additional-photo-delete-confirm.title',
    defaultMessage: 'Are you sure you want to delete this photo?',
  },
  accept: {
    id: 'venue-page.additional-photo-delete-confirm.accept',
    defaultMessage: 'Delete photo',
  },
  cancel: {
    id: 'venue-page.additional-photo-delete-confirm.cancel',
    defaultMessage: 'Cancel',
  },
});

const AdditionalPhotoDeleteConfirm = () => (
  <Confirm
    title={<Message message={messages.title} />}
    acceptNode={<Message message={messages.accept} />}
    cancelNode={<Message message={messages.cancel} />}
  />
);

export default AdditionalPhotoDeleteConfirm;
